import React, { useState } from 'react';
import * as Comp from './PuckComps';

import Alert from 'react-bootstrap/Alert';
import { migrate } from "@measured/puck";
import { config } from './EditorConfig';
import { startRouteTracking, endRouteTracking, initUnloadTracking } from '@services/route-tracking';

class PuckPageView extends React.Component {
    constructor(props) {
        super(props);
        const migratedData = migrate(Window.react_data, config)
        this.state = {
            alert: Window.react_data.alert,
            contentData: migratedData
        }
    }

    componentDidMount() {
        const routeName = Window.react_data?.title || 'puck_page';
        startRouteTracking(routeName);
        initUnloadTracking();
    }

    componentWillUnmount() {
        endRouteTracking();
    }

    render() {
        return (
            <>
                {/* We show this alert if the page is not live but an Admin is viewing the page for review */}
                {this.state.alert ? (
                    <Alert className="text-center mx-3 mt-2 mb-0" variant="danger" onClose={() => this.setState({ alert: false })} dismissible>
                        <Alert.Heading>Warning!</Alert.Heading>
                        <p className="mb-0">{this.state.alert}</p>
                    </Alert>
                ) : null}

                {this.state.contentData.content.map((component, index) => {
                    // Fetch the correct component to render
                    let Component = Comp[component.type];

                    return <Component key={index} {...component.props} />
                })}

            </>
        );
    }
}

export default PuckPageView;
